import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "inputRef", "mask", "maskPlaceholder", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"];

/* eslint-disable import/no-named-as-default */
import * as React from 'react';
import ReactInputMask from 'react-input-mask';
import { Input } from '../Input';
import { useOnChange } from './internal/hooks/useOnChange';
var MaskedInputComponent = /*#__PURE__*/React.forwardRef(function MaskedInput(props, ref) {
  var disabled = props.disabled,
      inputRef = props.inputRef,
      mask = props.mask,
      maskPlaceholder = props.maskPlaceholder,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onMouseDown = props.onMouseDown,
      readOnly = props.readOnly,
      value = props.value,
      restProps = _objectWithoutProperties(props, _excluded);

  var handleChange = useOnChange(onChange);
  return /*#__PURE__*/React.createElement(ReactInputMask, {
    disabled: disabled,
    inputRef: inputRef,
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    onBlur: onBlur,
    onChange: handleChange,
    onFocus: onFocus,
    onMouseDown: onMouseDown,
    readOnly: readOnly,
    type: "text",
    value: value
  }, /*#__PURE__*/React.createElement(Input, _extends({}, restProps, {
    ref: ref
  })));
});
export var MaskedInput = /*#__PURE__*/React.memo(MaskedInputComponent);